import { Button } from '@mui/material';
import { FC, useState } from 'react';
import { useSelector } from 'react-redux';
import { getSwissPostAvailableEms } from 'redux/reducers/swissPost/selectors';
import { ConnectClientDialog } from './ConnectClientDialog';

export const ConnectClientToSwissPost: FC = () => {
	const [connectClientDialogOpen, setConnectClientDialogOpen] = useState(false);
	const handleConnectClientDialogClose = () => {
		setConnectClientDialogOpen(false);
	};
	const handleConnectClientDialogOpen = () => {
		setConnectClientDialogOpen(true);
	};
	const availableEms = useSelector(getSwissPostAvailableEms);

	return (
		<>
			<Button
				variant="contained"
				color="primary"
				size="small"
				onClick={handleConnectClientDialogOpen}
				sx={{
					textTransform: 'none',
					fontSize: '.8rem',
				}}
				disabled={!availableEms || !availableEms.length}
			>
				Connect Client to Swiss Post
			</Button>
			<ConnectClientDialog
				open={connectClientDialogOpen}
				setClose={handleConnectClientDialogClose}
			/>
		</>
	);
};
